import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { CalendarDays, ChevronDown, Menu, Search, X } from 'lucide-react';

export const specialties = [
  'Anaesthesiology','Blood Center','Cardiology','Cardiothoracic & Vascular Surgery',
  'Critical Care','Dentistry','ENT','Emergency Medicine','Gastroenterology',
  'General Medicine','General Surgery','Gynaecology & Obstetrics','Interventional Radiology',
  'Medical Diagnostics','Medical Imaging','Nephrology','Neurology','Neurosurgery',
  'Nuclear Medicine','Haemato-Oncology & BMT','Medical Oncology','Radiation Oncology',
  'Surgical Oncology','Orthopaedics','Ophthalmology','Plastic & Reconstructive Surgery',
  'Pulmonology','Urology'
];

const slugify = (value) => value.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');

export const menus = [
  { label:'About', to:'/about', items:[
    ['Overview','/about/overview'],['Our Expertise','/about/our-expertise'],['Why Choose Us','/about/why-choose-us']
  ]},
  { label:'Our Specialties', to:'/departments', mega:true, items:specialties.map(name=>[name,`/specialties/${slugify(name)}`]) },
  { label:'Our Experts', to:'/doctors' },
  { label:'Patient Info', to:'/patient-info', items:[
    ['Patient Rights & Responsibilities','/patient-info/rights-responsibilities'],
    ['Food & Beverages','/patient-info/food-beverages'],
    ['Pharmacy Services','/patient-info/pharmacy-services']
  ]},
  { label:'Health Check Packages', to:'/health-packages', items:[
    ['Basic Health Check','/health-packages/basic'],
    ['Cardiac Health Check','/health-packages/cardiac'],
    ['Executive Health Check','/health-packages/executive'],
    ['Executive Health Check – 45+','/health-packages/executive-45-plus'],
    ['Well Woman Check','/health-packages/well-woman'],
    ['Kidney Health Check','/health-packages/kidney'],
    ['Cardiac Profile','/health-packages/cardiac-profile']
  ]},
  { label:'Patient Portal', to:'/patient-portal' },
  { label:'Careers', to:'/careers' },
  { label:'Contact', to:'/contact' }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [mobileMenu, setMobileMenu] = useState('');
  const closeAll = () => { setOpen(false); setMobileMenu(''); };
  return <>
    <div className="topbar"><div className="container topbar-inner"><span>For Emergency: <strong>+91 76500 00108</strong></span><span>Balapur, RR District, Hyderabad · info@asianaxxonhospitals.com</span></div></div>
    <header className="site-header">
      <div className="container nav-wrap">
        <Link className="brand" to="/" aria-label="Asian Axxon Hospitals home" onClick={closeAll}><img className="site-logo" src="/assets/logo/hospital-logo.png" alt="Asian Axxon Hospitals"/></Link>
        <nav className={open ? 'nav-links open' : 'nav-links'} aria-label="Main navigation">
          {menus.map(menu => <div className={`nav-item ${menu.items ? 'has-dropdown' : ''} ${menu.mega ? 'has-mega' : ''}`} key={menu.label}>
            <div className="nav-label">
              <NavLink to={menu.to} onClick={closeAll}>{menu.label}</NavLink>
              {menu.items && <button aria-label={`Toggle ${menu.label} menu`} aria-expanded={mobileMenu===menu.label} onClick={()=>setMobileMenu(mobileMenu===menu.label?'':menu.label)}><ChevronDown size={13}/></button>}
            </div>
            {menu.items && <div className={`dropdown ${mobileMenu===menu.label?'mobile-open':''}`}>
              {menu.mega && <div className="mega-intro"><small>Clinical excellence</small><h3>Our Specialties</h3><p>Multidisciplinary care backed by advanced diagnostics and experienced specialists.</p><Link to="/departments" onClick={closeAll}>View all specialties →</Link></div>}
              <div className="dropdown-links">{menu.items.map(([label,to])=><Link to={to} key={to} onClick={closeAll}>{label}</Link>)}</div>
            </div>}
          </div>)}
        </nav>
        <div className="nav-actions">
          <Link className="icon-btn" to="/search" aria-label="Search"><Search size={20}/></Link>
          <Link className="btn btn-primary" to="/appointment"><CalendarDays size={18}/> Book appointment</Link>
          <button className="menu-btn" onClick={() => setOpen(!open)} aria-label="Toggle menu">{open ? <X/> : <Menu/>}</button>
        </div>
      </div>
    </header>
  </>;
}
